export default __webpack_public_path__ + "static/media/close.3f339f8a.svg";